import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getGlobalManufacturers = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/global-manufacturer`);
    return response.data;
  } catch (error) {
    console.error('Error fetching global manufacturers:', error.response?.data || error);
    throw error;
  }
};

export const getGlobalManufacturerById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/global-manufacturer/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching global manufacturer:', error.response?.data || error);
    throw error;
  }
};

export const createGlobalManufacturer = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/global-manufacturer`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating global manufacturer:', error.response?.data || error);
    throw error;
  }
};

export const updateGlobalManufacturer = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/global-manufacturer/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating global manufacturer:', error.response?.data || error);
    throw error;
  }
};

export const deleteGlobalManufacturer = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/global-manufacturer/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting global manufacturer:', error.response?.data || error);
    throw error;
  }
};
